module.exports = __webpack_public_path__ + "img/img-2.a0a6f224.jpg";